'use strict';

import { commitMutation, graphql } from 'react-relay';

const mutation = graphql`
    mutation TagProjectMutation($input: FavoriteItemInput!, $userId: String!) {
        favoriteItem(input: $input) {
            item {
                isFavorite(userId: $userId)
                serviceId
                projects(userId: $userId) {
                    serviceId
                    name
                    portfolio {
                        serviceId
                    }
                }
            }
        }
    }
`;

export function commit(environment, args) {
    const { action = 'ADD', userId, itemId, portfolioId, onCompleted, onError } = args;

    const input = {
        action,
        userId,
        itemId,
        portfolioId,
    };

    commitMutation(environment, {
        mutation,
        variables: {
            input,
            userId,
        },
        onCompleted,
        onError,
    });
}

export default { commit };
